import { PRODUCT_MANAGEMENT_TYPE, PRODUCT_MANAGEMENT_TYPE_TEXT } from './productConstants';

/**
 *  페이지 이름
 */
export const BALANCE_PAGE_NAME = {
  BALANCE_WAITING_LIST: '정산 대기목록',
  BALANCE_DONE_LIST: '정산 완료목록',
  BALANCE_HOLD_LIST: '정산 보류목록',
  BALANCE_DETAIL: '정산 상세',
  BALANCE_BRAND_LIST: '브랜드별 정산 타입 목록',
  BALANCE_DATE_ADJUSTMENT: '정산 기준일 변경',
  BALANCE_COMPLETE_DATE_ADJUSTMENT: '정산 완료일 변경',
};

/**
 *  정산 상태
 */
export const BALANCE_STATUS = {
  /**
   *  정산 준비
   */
  READY: 0,
  /**
   *  정산 대기
   */
  WAITING: 1,
  /**
   *  정산 일부 완료
   */
  PART_DONE: 2,
  /**
   *  정산 완료
   */
  DONE: 3,
  /**
   *  정산 보류
   */
  HOLD: 4,
};

/**
 *  정산 상태 TEXT
 */
export const BALANCE_STATUS_TEXT = {
  0: '정산 준비',
  1: '정산 대기',
  2: '정산 일부 완료',
  3: '정산 완료',
  4: '정산 보류',
};

/**
 *  정산 계좌 은행명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_BANK_NAME_TEXT = 20;

/**
 *  정산 계좌 예금주 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_HOLDER_TEXT = 50;

/**
 *  정산 계좌번호 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_NUMBER_TEXT = 30;

/**
 *  정산 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_MEMO_TEXT = 200;

/**
 *  정산 최소 금액 (공통)
 */
export const BALANCE_COMMON_MINIMUM_PRICE = 0;

/**
 *  정산 최대 금액 (공통)
 */
export const BALANCE_COMMON_MAXIMUM_PRICE = 100000000;

/**
 *  정산 리스트가 없을 때 보여주는 텍스트
 */
export const BALANCE_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 정산 리스트가 없습니다.';

/**
 *  정산 아이템 타입 TEXT
 */
export const BALANCE_ITEM_TYPE_TEXT = {
  0: '상품 주문',
  1: '배송비 ',
  2: '반품 건',
};

/**
 *  정산 데이터 업데이트 confirm 메시지
 */
export const UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE = {
  /**
   *  정산처리
   */
  EXECUTION: 0,
  /**
   *  정산 일부완료
   */
  PART_EXECUTION: 1,
  /**
   *  강제처리
   */
  FORCE_EXECUTION: 2,
  /**
   *  편집
   */
  EDIT_BALANCE: 3,
};

/**
 *  정산 데이터 업데이트 confirm 메시지
 */
export const UPDATE_BALANCE_CONFIRM_MESSAGE = {
  /**
   *  정산처리
   */
  0: {
    title: '정산처리',
    message: '정산처리가 진행됩니다. 진행을 하시겠습니까?',
  },
  /**
   *  정산 일부완료
   */
  1: {
    title: '정산 일부완료',
    message: '정산이 완료되지 않고 정산 보류상태가 됩니다. 그래도 진행을 하시겠습니까?',
  },
  /**
   *  강제처리
   */
  2: {
    title: '정산 강제처리',
    message: '정산 집행 금액이 정산 예정 금액과 다릅니다. 그래도 진행을 하시겠습니까?',
  },
  /**
   *  편집
   */
  3: {
    title: '수정하기',
    message: '수정을 진행을 하시겠습니까?',
  },
};

/**
 *  정산일 검색 타입
 */
export const BALANCE_SEARCH_DATE_TYPE = {
  /**
   *  정산 예정일
   */
  DUE_DATE: 0,
  /**
   *  정산 완료일
   */
  COMPLETE_DATE: 1,
};

/**
 *  정산일 검색 타입 텍스트
 */
export const BALANCE_SEARCH_DATE_TYPE_TEXT = {
  [BALANCE_SEARCH_DATE_TYPE.DUE_DATE]: '정산 예정일',
  [BALANCE_SEARCH_DATE_TYPE.COMPLETE_DATE]: '정산 완료일',
};

/**
 *  정산 일괄 처리 유효성 검사 결과 타입
 */
export const BALANCE_BULK_EDIT_INVALID_TYPE = {
  /**
   *  상태가 올바르지 않음.
   *  정산대기 또는 정산보류가 아님
   */
  INVALID_STATUS: 0,
};

/**
 *  정산 일괄 처리 유효성 검사 결과 타입 텍스트
 */
export const BALANCE_BULK_EDIT_INVALID_TYPE_TEXT = {
  /**
   *  상태가 올바르지 않음.
   */
  [BALANCE_BULK_EDIT_INVALID_TYPE.INVALID_STATUS]: '정산 상태가 정산 대기 또는 정산 보류가 아닙니다.',
};

/**
 *  정산주기 타입
 */
export const BALANCE_PERIOD_TYPE = {
  /**
   *  일간 정산
   */
  DAILY: 0,
  /**
   *  월간 정산
   */
  MONTHLY: 1,
};

/**
 *  정산주기 타입 텍스트
 */
export const BALANCE_PERIOD_TYPE_TEXT = {
  /**
   *  일간 정산
   */
  [BALANCE_PERIOD_TYPE.DAILY]: '일간 정산',
  /**
   *  월간 정산
   */
  [BALANCE_PERIOD_TYPE.MONTHLY]: '월간 정산',
};

/**
 *  정산주기 타입 SELECT LIST
 */
export const BALANCE_PERIOD_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: BALANCE_PERIOD_TYPE.DAILY,
    name: BALANCE_PERIOD_TYPE_TEXT[BALANCE_PERIOD_TYPE.DAILY],
  },
  {
    id: BALANCE_PERIOD_TYPE.MONTHLY,
    name: BALANCE_PERIOD_TYPE_TEXT[BALANCE_PERIOD_TYPE.MONTHLY],
  },
];

/**
 *  브랜드 상세 정산주기 타입 SELECT LIST
 */
export const BALANCE_DETAIL_PERIOD_TYPE_SELECT_LIST = [
  {
    id: BALANCE_PERIOD_TYPE.DAILY,
    name: BALANCE_PERIOD_TYPE_TEXT[BALANCE_PERIOD_TYPE.DAILY],
  },
  {
    id: BALANCE_PERIOD_TYPE.MONTHLY,
    name: BALANCE_PERIOD_TYPE_TEXT[BALANCE_PERIOD_TYPE.MONTHLY],
  },
];

/**
 *  기본 월간 정산일
 */
export const DEFAULT_MONTHLY_BALANCE_DAY = 15;

/**
 *  기본 월간 정산 주기
 */
export const DEFAULT_MONTHLY_BALANCE_PERIOD = 1;

/**
 *  최소 월간정산일
 */
export const MINIMUM_MONTHLY_BALANCE_DAY = 6;

/**
 *  최대 월간정산일
 */
export const MAXIMUM_MONTHLY_BALANCE_DAY = 27;

/**
 *  최소 월간 정산주기
 */
export const MINIMUM_MONTHLY_BALANCE_PERIOD = 1;

/**
 *  최대 월간 정산주기
 */
export const MAXIMUM_MONTHLY_BALANCE_PERIOD = 12;

/**
 *  정산 생성 관리 주체
 */
export const BALANCE_CREATE_MANAGEMENT_TYPE = {
  SCHEDULER: 0,
  ADMIN: 1,
};

/**
 *  정산 생성 관리 주체 텍스트
 */
export const BALANCE_CREATE_MANAGEMENT_TYPE_TEXT = {
  [BALANCE_CREATE_MANAGEMENT_TYPE.SCHEDULER]: '스케줄러',
  [BALANCE_CREATE_MANAGEMENT_TYPE.ADMIN]: '어드민',
};

// PG 수수료 여부 타입
export const PG_FEE_TYPE = {
  OFF: 0,
  ON: 1,
};

// PG 수수료 여부 타입 텍스트
export const PG_FEE_TYPE_TEXT = {
  [PG_FEE_TYPE.OFF]: 'OFF',
  [PG_FEE_TYPE.ON]: 'ON',
};

// 상품 타입 타입 SELECT LIST
export const BALANCE_BRAND_LIST_PRODUCT_MANAGEMENT_TYPE_CHECKBOX_LIST = [
  {
    id: PRODUCT_MANAGEMENT_TYPE.ENTER,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.ENTER],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.PURCHASE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.PURCHASE],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.INCOME,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.INCOME],
  },
  {
    id: PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE,
    name: PRODUCT_MANAGEMENT_TYPE_TEXT[PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE],
  },
];

// 정산 브랜드 서치박스 label 부분 TYPE
export const BALANCE_BRAND_SEARCH_BOX_TYPE = {
  STORE_ID: 0,
  STORE_NAME: 1,
};

// 정산 브랜드 서치박스 label 부분 TEXT
export const BALANCE_BRAND_SEARCH_BOX_TEXT = {
  [BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_ID]: '브랜드 ID',
  [BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_NAME]: '브랜드명',
};

// 정산 브랜드 서치박스 label 부분 SELECT LIST
export const BALANCE_BRAND_SEARCH_BOX_SELECT_LIST = [
  {
    id: BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_ID,
    name: BALANCE_BRAND_SEARCH_BOX_TEXT[BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_ID],
  },
  {
    id: BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_NAME,
    name: BALANCE_BRAND_SEARCH_BOX_TEXT[BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_NAME],
  },
];

// 정산 브랜드 서치박스에서 userId 의 쵀대 길이
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_STORE_ID = 1000;
